exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\r\nStylesheet for the page to list the exemplary business models.\r\n@author Adrian Rebmann, Steffen Schuhmann, Andrea Villeda\r\n*/\n.margin-twenty {\r\n  margin-bottom: 20px;\n}\n.md-subhead {\r\n  min-height: 70px;\n}\r\n", "", {"version":3,"sources":["/home/gitlab-runner/builds/b21bf5d0/0/mkz/werner-frontend/src/components/company/businessmodel/example/bmexample.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;EACE,oBAAoB;CACrB;AAED;EACE,iBAAiB;CAClB","file":"bmexample.css","sourcesContent":["/*\r\nStylesheet for the page to list the exemplary business models.\r\n@author Adrian Rebmann, Steffen Schuhmann, Andrea Villeda\r\n*/\r\n\r\n.margin-twenty {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.md-subhead {\r\n  min-height: 70px;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42302abc","scoped":false,"hasInlineConfig":false}!./src/components/company/businessmodel/example/bmexample.css
// module id = X8nf
// module chunks = 1